import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { Flex } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import ListPageCardHeader from "components/Card/ListPageCardHeader";
import Loading from "components/Loading/Loading";
import SearchTable2 from "components/Tables/SearchTable2";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { ROUTES } from "constants/routes-path";
import { publicBoatService } from "services/publicBoatService";

function PublicBoatList() {
    const navigate = useNavigate();
    const showToast = useCustomToast();
    const [data, setData] = useState(undefined);

    const columns = useMemo(() => [
        {
            Header: "Núm. BOAT",
            accessor: "boatNumber",
        },
        {
            Header: "Data de Solicitação",
            accessor: "createdAt",
            custom: ({ value }) => new Date(value).toLocaleString(),
        },
        {
            Header: "Declarante",
            accessor: "declarantData.nome",
        },
        {
            Header: "Ações",
            disableSortBy: true,
            actions: [
                {
                    label: "Visualizar",
                    icon: <FaEye />,
                    onClick: (row) =>
                        navigate(
                            ROUTES.publicBoatDetailsPath.replace(":id", row.original.id),
                            { state: { boat: row.original } }
                        ),
                },
            ],
        },
    ], []);

    const fetchData = async () => {
        setData(undefined);
        try {
            const response = await publicBoatService.listByStatus("SOLICITADO");
            setData(response);
        } catch (err) {
            setData([]);
            showToast({ title: err, status: "error" });
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Flex gap="5" direction="column" pt={{ base: "150px", lg: "90px" }}>
            <Card overflowX={{ sm: "scroll", lg: "hidden" }}>
                <ListPageCardHeader title="BOST Públicos" subtitle="Solicitações de BOST pendentes de análise de agentes" />

                <CardBody>
                    {data ? (
                        <SearchTable2
                            columnsData={columns}
                            tableData={data}
                        />
                    ) : (
                        <Loading maxH={{ sm: "100px", md: "350px" }} />
                    )}
                </CardBody>
            </Card>
        </Flex>
    );
}

export default PublicBoatList;
